import React from 'react';

import { StyledBadge } from './Badge.styles';
import { TBadgeProps } from './Badge.types';

const Badge = ({ tone, variant = 'solid', size = 'md', children, ...props }: TBadgeProps) => (
  <StyledBadge $tone={tone} $variant={variant} $size={size} {...props}>
    {children}
  </StyledBadge>
);

export default Badge;
